<template>
    <div class="flex flex-wrap gap-2 justify-end">
        <slot></slot>
        
        <!-- Pulsante di refresh -->
        <Button 
            icon="pi pi-refresh" 
            @click="$emit('refresh')"
            :loading="loading"
            severity="secondary"
            text
        />

        <!-- Pulsante di export -->
        <Button 
            v-if="showExport"
            icon="pi pi-download" 
            @click="$emit('export')"
            :loading="exporting"
            severity="secondary"
            text
        />
    </div>
</template>

<script setup>
defineProps({
    loading: {
        type: Boolean,
        default: false
    },
    exporting: {
        type: Boolean,
        default: false
    },
    showExport: {
        type: Boolean,
        default: false
    }
});

defineEmits(['refresh', 'export']);
</script>

<style module>
    .headerButtonTable {
        padding: 0.40rem 0.75rem !important;
    }
</style>